import { Page } from "components/page";
import { type GetStaticProps, type NextPage } from "next";
import { type MDXRemoteSerializeResult } from "next-mdx-remote";
import { serialize } from "next-mdx-remote/serialize";
import rehypeHighlight from "rehype-highlight";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";
import React from "react";
import { LegalPage } from "components/legal";
import { currentVersion } from "data/legal/terms-of-service";

type PageProps = {
  documentSource: MDXRemoteSerializeResult;
};

const TermsOfService: NextPage<PageProps> = ({ documentSource }) => {
  return (
    <Page
      title="Terms of Service"
      description="These Terms of Service (“Terms of Service” or “Terms”), together with an Order Form, govern a customer’s use
    of https://hightouch.com"
      footerOptions={{ hideCta: true }}
    >
      <LegalPage
        title="Terms of Service"
        lastUpdatedDate={currentVersion.date}
        mdxSource={documentSource}
        currentVersionSlug="terms-of-service"
      />
    </Page>
  );
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  const mdx = currentVersion.content;

  const documentSource = await serialize(mdx, {
    mdxOptions: {
      rehypePlugins: [rehypeSlug, rehypeHighlight],
      remarkPlugins: [remarkGfm],
      format: "md",
    },
  });

  return { props: { documentSource } };
};

export default TermsOfService;
